module.exports = __webpack_public_path__ + "img/qrCode_gzh.e294a64c.jpg";